import { CircleGraph } from '@/ui/components';

import StatisticsRow from '../StatisticsRow';
import StatisticsLabel from '../StatisticsLabel';

interface RowLabelAndCircularGraphProps {
  /** Additional CSS classes to apply to the row container. */
  className?: string;
  /** Label describing the statistic, e.g. "Games Played", "% Victory". */
  label: string;
  /** Number (float, percentage) for the home team (0-1). */
  homeNumber: number;
  /** Number (float, percentage) for the away team (0-1). */
  awayNumber: number;
}

export default function RowLabelAndCircularGraph({
  className = '',
  label,
  homeNumber,
  awayNumber,
}: RowLabelAndCircularGraphProps) {
  return (
    <StatisticsRow className={className}>
      <CircleGraph progress={homeNumber} />
      <StatisticsLabel>{label}</StatisticsLabel>
      <CircleGraph progress={awayNumber} useOrange />
    </StatisticsRow>
  );
}
